import { render } from "./HeroTitle.vue?vue&type=template&id=81697d5a"
import script from "./HeroTitle.vue?vue&type=script&lang=js"
export * from "./HeroTitle.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__